import React, { useState } from 'react';
import './EnterpriseSection.css';
import { API } from '../services/apiConfig';

function EnterpriseSection() {
  const [form, setForm] = useState({
    name: '', email: '', company: '', category: '', requirement: '', quantity: ''
  });
  const [status, setStatus] = useState(null); // 'success' | 'error'
  const [submitting, setSubmitting] = useState(false);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const inputProps = (placeholder, key, type = 'text') => ({
    type,
    placeholder,
    value: form[key],
    onChange: set(key),
    className: 'ent-input',
  });

  const handleSubmit = async () => {
    if (!form.name || !form.email) return;
    setSubmitting(true);
    try {
      const res = await fetch(`${API}/api/enterprise`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (res.ok) {
        setStatus('success');
        setForm({ name: '', email: '', company: '', category: '', requirement: '', quantity: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div id="enterprise" className="ent-outer">
      <div className="ent-row">

        {/* ── Left red card ── */}
        <div className="ent-left" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/enterpirse%20bg%201.png)`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
          <div className="ent-overlay" />
          <div className="ent-left-content">
            <h2 className="ent-heading">Enterprise and<br />Bulk Orders</h2>
            <p className="ent-desc">
              From onboarding kits to festive gifting, corgif supports high-volume
              orders with flexible customisation, reliable timelines, and dedicated
              coordination.
            </p>
          </div>
        </div>

        {/* ── Right form card ── */}
        <div className="ent-right">
          <h3 className="ent-form-title">Let's Plan Your Corporate Gifting!</h3>
          <p className="ent-form-sub">
            Prefer to speak directly? Call us at{' '}
            <span className="ent-phone">+91 9823666128</span> for immediate assistance.
          </p>

          {status === 'success' && (
            <div className="ent-alert ent-alert-success">✅ Request submitted! We'll get back to you shortly.</div>
          )}
          {status === 'error' && (
            <div className="ent-alert ent-alert-error">❌ Something went wrong. Please try again.</div>
          )}

          <input {...inputProps('Full Name *', 'name')} />
          <input {...inputProps('Work Email ID *', 'email', 'email')} />
          <input {...inputProps('Company Name', 'company')} />
          <input {...inputProps('Preferred Gifting Category', 'category')} />
          <textarea
            placeholder={'Type of Requirement\nProduct type or name/code'}
            value={form.requirement}
            onChange={set('requirement')}
            className="ent-textarea"
          />
          <input {...inputProps('Estimated Quantity (optional)', 'quantity', 'number')} />

          <button className="ent-submit" onClick={handleSubmit} disabled={submitting}>
            {submitting ? 'Submitting...' : 'Submit Request'}
          </button>
        </div>

      </div>
    </div>
  );
}

export default EnterpriseSection;
